import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {StandingsClickEventHandler} from "../../../core/handlers/standings-click-event.handler";
import {TopStatsClickEventHandler} from "../../../core/handlers/top-stats-click-event.handler";
import {SquadClickEventHandler} from "../../../core/handlers/squad-click-event.handler";
import {BracketsClickEventHandler} from "../../../core/handlers/brackets.click-event.handler";
import {NavigationTabsTabClickEventHandler} from "./navigation-tabs.tab-click.event.handler";
import {MatchDetailsClickEventHandler} from "../../../core/handlers/match-details.click-event.handler";
import {LineupsClickEventHandler} from "../../../core/handlers/lineups.click-event.handler";
import {StatsClickEventHandler} from "../../../core/handlers/stats-click-event.handler";
import {H2hClickEventHandler} from "../../../core/handlers/h2h-click-event.handler";

export class NavigationTabsModuleHandlers extends HandlerList {
  static injectables = [
    NavigationTabsTabClickEventHandler,
    StandingsClickEventHandler,
    BracketsClickEventHandler,
    TopStatsClickEventHandler,
    SquadClickEventHandler,
    MatchDetailsClickEventHandler,
    LineupsClickEventHandler,
    StatsClickEventHandler,
    H2hClickEventHandler,
    TimingHandler,
    PopulateDataHandler
  ];

  constructor(
    navigationTabsTabClickEventHandler: NavigationTabsTabClickEventHandler,
    standingsClickEventHandler: StandingsClickEventHandler,
    bracketsClickEventHandler: BracketsClickEventHandler,
    topStatsClickEventHandler: TopStatsClickEventHandler,
    squadClickEventHandler: SquadClickEventHandler,
    matchDetailsClickEventHandler: MatchDetailsClickEventHandler,
    lineupsClickEventHandler: LineupsClickEventHandler,
    statsClickEventHandler: StatsClickEventHandler,
    h2hClickEventHandler: H2hClickEventHandler,
    timingHandler: TimingHandler,
    populateDataHandler: PopulateDataHandler
  ) {
    super();

    [
      navigationTabsTabClickEventHandler,
      standingsClickEventHandler,
      bracketsClickEventHandler,
      topStatsClickEventHandler,
      squadClickEventHandler,
      matchDetailsClickEventHandler,
      lineupsClickEventHandler,
      statsClickEventHandler,
      h2hClickEventHandler,
      timingHandler,
      populateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
